// eslint-ignore-unused-vars
// assets
import { IconFileSettings, IconUserCircle 
    // ,IconSettings2,IconSettingsAutomation
     } from '@tabler/icons';
const icons = {
    IconFileSettings, IconUserCircle
};

const adminPages = {
    id: 'admin-pages',
    title: 'Admin Pages',
    icon: icons.IconFileSettings,
    type: 'group',
    children: [
        {
            id: 'staff-page',
            title: 'Staff',
            icon: icons.IconUserCircle,
            type: 'item',
            url: '/staff-page',
            breadcrumbs: true
        },
        {
            id: 'general-page',
            title: 'General',
            icon: icons.IconFileSettings,
            type: 'item',
            url: '/general-page',
            breadcrumbs: true
        },
    ]
};

export default adminPages;
